var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{on:{"click":function($event){return _vm.onClick(_vm.modelValue)}}},[(!!_vm.icon)?_c('v-icon',{attrs:{"small":"","color":"primary"}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v(" "+_vm._s(_vm.linkText?_vm.linkText:_vm.selectModel(_vm.modelValue,_vm.dataSelectorKey))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }